import { Modal } from '@app/components/various/Modal';
import { useModalVisibility } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';

import { DimensionSelectors } from './DimensionSelectors';
import { OverviewTable } from './OverviewTable';
import { SelectionOverviewContextProvider } from './SelectionOverviewContext';
import { VariantsFilters } from './VariantsFilters';
import { ViewOptions } from './ViewOptions';

export const SelectionOverviewModal = () => {
  const { t } = useTranslation(['common', 'totals', 'products', 'selectionOverview']);
  const { isModalVisible, hideModal } = useModalVisibility('SelectionOverviewModal');

  return (
    <Modal isOpen={isModalVisible} size="xxlarge" onClose={hideModal} title={t('selectionOverview:selection_overview')}>
      <SelectionOverviewContextProvider>
        <div className="mb-6 mt-2 flex flex-wrap items-end gap-4">
          <ViewOptions />
          <DimensionSelectors />
          <VariantsFilters />
        </div>
        <OverviewTable />
      </SelectionOverviewContextProvider>
    </Modal>
  );
};
